/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget';

export class AzureVmInstanceRestoreDestination {
  'azureVm'?: AzureVmInstanceRestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "azureVm",
      "baseName": "azureVm",
      "type": "AzureVmInstanceRestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVmInstanceRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

